





















import { Component, Vue, Watch } from 'vue-property-decorator';
import { AppModule, AppTheme } from '@/store/modules/app';
import { UserModule } from '@/store/modules/user';
import AppSidebarItems from './AppSidebarItems.vue';

@Component({
  name: 'AppSidebar',
  components: {
    AppSidebarItems,
  },
})
export default class extends Vue {
  items = [
    { title: 'Home', icon: 'mdi-home-city', to: '/home' },
    { title: 'About', icon: 'mdi-account', to: '/about' },
  ];
  mini = false;

  get appName() {
    return this.$t(process.env.VUE_APP_NAME as string);
  }

  get isMobile() {
    return this.$vuetify.breakpoint.mdAndDown;
  }

  get isSidebarOpen() {
    return AppModule.sidebar.opened || !this.isMobile;
  }

  get isMini() {
    return !AppModule.sidebar.opened && !this.isMobile;
  }

  set isMini(v: boolean) {}

  get logoColor() {
    return AppModule.theme === AppTheme.Light ? 'grey lighten-3' : 'white';
  }

  private handleSidebarInput(opened: boolean) {
    if (opened !== AppModule.sidebar.opened) {
      AppModule.ToggleSideBar();
    }
  }
}
